import React from 'react';
import useGeneratedPayrollsService, {
  PAYROLL_REPORT_STATUSES,
  REJECT_PAYROLL_REPORT,
} from 'domain/finance/payroll/generatedPayrolls/useGeneratedPayrollsService';
import { useFieldHelper } from 'framework/ui/field';
import { DeleteButton } from 'framework/ui/ui-builder';
import { ListItem, useListContext } from 'framework/list';
import { useShowContext } from 'framework/show';

const RejectPayrollReportButton = ({ statusSource }: { statusSource: string }) => {
  const { rejectPayrollReport } = useGeneratedPayrollsService();
  const { getValue } = useFieldHelper({ source: statusSource });
  const { updateInList = () => {} } = useListContext();
  const status = getValue();
  const { data } = useShowContext();
  const contextData = data.getData() || {};

  if (status !== PAYROLL_REPORT_STATUSES.APPROVED) {
    return null;
  }

  return (
    <DeleteButton
      displayMessage="Do you really want to reject this report?"
      deleteMethod={() => rejectPayrollReport(contextData.id)}
      afterDelete={{
        successMessage: 'The Report has been successfully rejected',
        errorMessage: "Can't reject this report.",
        execute: () => {
          updateInList({ ...contextData, status: PAYROLL_REPORT_STATUSES.PENDING } as ListItem);
        },
      }}
      permissionToCheck={REJECT_PAYROLL_REPORT}
      buttonText="Reject"
      color="error"
    />
  );
};

export default RejectPayrollReportButton;
